"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var rxjs_1 = require("rxjs");
require("rxjs/add/operator/map");
require("rxjs/add/operator/first");
/**
 * Http Implementation of ApplicationPropertiesService
 */
var HttpApplicationPropertiesService = /** @class */ (function () {
    /**
     * Construct HttpApplicationPropertiesService instance, loads all  application properties from server
     * @param http
     */
    function HttpApplicationPropertiesService(http) {
        this.http = http;
        this.appPropertiesUrl = 'properties/urls';
        this.buildVersionUrl = 'properties/version';
        this.staticResourcesUrl = 'properties/static-resources-url';
        this.categoriesIconsPathSuffix = 'categories/icons/';
        this.featuresUrl = 'features';
        this.projectConfigs = 'properties/project-configs';
        this.appPropertiesReplaySubject = new ReplaySubject_1.ReplaySubject(1);
        this.loadApplicationProperties();
    }
    HttpApplicationPropertiesService_1 = HttpApplicationPropertiesService;
    /**
     * Concerts object to Map
     * @param obj
     * @returns {Map<string, string>}
     */
    HttpApplicationPropertiesService.convertObjectToMap = function (obj) {
        var strMap = new Map();
        for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
            var k = _a[_i];
            strMap.set(k, obj[k]);
        }
        return strMap;
    };
    /**
     * Handles errors
     * @param error
     */
    HttpApplicationPropertiesService.handleError = function (error) {
        var errMsg = (error.message) ? error.message :
            error.status ? error.status + " - " + error.statusText : 'Server error';
        console.error(errMsg);
        return rxjs_1.Observable.throw(errMsg);
    };
    /**
     *
     * @param key
     * @returns property which is associated with this key
     */
    HttpApplicationPropertiesService.prototype.getProperty = function (key) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            return _this.appPropertiesReplaySubject.asObservable().first().subscribe(function (properties) {
                var value = properties.get(key);
                value ? resolve(value) : reject("Url for " + key + " key isn't present!");
            });
        });
    };
    /**
     * Returns "v0"
     * @returns {Promise<string>}
     */
    HttpApplicationPropertiesService.prototype.getBuildVersion = function () {
        return this.http.get(this.buildVersionUrl, { responseType: 'text' }).toPromise().then(function (res) {
            return res;
        }).catch(HttpApplicationPropertiesService_1.handleError);
    };
    HttpApplicationPropertiesService.prototype.getStaticResourcesUrl = function () {
        if (this.staticResourcesUrlPromise == null) {
            this.staticResourcesUrlPromise = this.loadStaticResourcesUrl();
        }
        return this.staticResourcesUrlPromise;
    };
    HttpApplicationPropertiesService.prototype.getCategoryIconsPath = function () {
        var _this = this;
        if (this.staticResourcesUrlPromise == null) {
            this.staticResourcesUrlPromise = this.loadStaticResourcesUrl();
        }
        return this.staticResourcesUrlPromise.then(function (url) { return url + _this.categoriesIconsPathSuffix; });
    };
    HttpApplicationPropertiesService.prototype.isOfflineApp = function () {
        return Promise.resolve(false);
    };
    HttpApplicationPropertiesService.prototype.isFeatureEnabled = function (featureName) {
        if (this.enabledFeaturesPromise == null) {
            this.enabledFeaturesPromise = this.loadEnabledFeatures();
        }
        return this.enabledFeaturesPromise.then(function (enabledFeatures) { return enabledFeatures.has(featureName); });
    };
    HttpApplicationPropertiesService.prototype.loadProjectConfigs = function () {
        return this.http.get(this.projectConfigs).toPromise();
    };
    HttpApplicationPropertiesService.prototype.loadEnabledFeatures = function () {
        return this.http.get(this.featuresUrl)
            .map(function (result) {
            return new Set(result);
        }).toPromise();
    };
    /**
     *  Loads all Application Properties from json file
     */
    HttpApplicationPropertiesService.prototype.loadApplicationProperties = function () {
        var _this = this;
        var dataPromise = this.http.get(this.appPropertiesUrl).toPromise();
        dataPromise.then(function (res) {
            _this.appPropertiesReplaySubject.next(HttpApplicationPropertiesService_1.convertObjectToMap(res));
            _this.appPropertiesReplaySubject.complete();
        }).catch(HttpApplicationPropertiesService_1.handleError);
    };
    /**
     *  Loads URL of static file
     */
    HttpApplicationPropertiesService.prototype.loadStaticResourcesUrl = function () {
        return this.http.get(this.staticResourcesUrl).map(function (data) { return data.url; }).toPromise();
    };
    HttpApplicationPropertiesService = HttpApplicationPropertiesService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], HttpApplicationPropertiesService);
    return HttpApplicationPropertiesService;
    var HttpApplicationPropertiesService_1;
}());
exports.HttpApplicationPropertiesService = HttpApplicationPropertiesService;
//# sourceMappingURL=http-application-properties.service.js.map